module.exports = __webpack_public_path__ + "static/img/twin-highway-4.e54176de.png";